/* eslint-disable nordic/i18n-jsx-no-literals */
const React = require('react');
const Tag = require('@andes/tag');
const Dropdown = require('@andes/dropdown');
const CopyToClipboard = require('react-copy-to-clipboard');
const { useLiveDemoContext } = require('./Provider/liveDemoContext');
const Download = require('./Images/download');
const Copy = require('./Images/copy');
const { addLineInCode, downloadString } = require('./utils');
const { getEventTracker } = require('../../../event-tracker');

const { DropdownItem } = Dropdown;

const { useState, useEffect } = React;

const snippetFront = ({ componentSnippetFront, i18n, liveDemoId }) => {
  const Tracker = getEventTracker();

  const { formData, setBehaviorData } = useLiveDemoContext();
  const contentAvailable = componentSnippetFront(formData, i18n);
  if (!contentAvailable || contentAvailable?.length < 1) {
    return <></>;
  }

  const filesAvailable = contentAvailable?.map((item) => item?.name);
  const [selectedContent, setSelectedContent] = useState(contentAvailable[0]);
  const [selectedFile, setSelectedFile] = useState(contentAvailable[0]?.name);

  useEffect(() => {
    const selectedItem = componentSnippetFront(formData, i18n).find(
      (item) => item?.name === selectedFile,
    );
    const formatCode = selectedItem?.code ? addLineInCode(selectedItem.code) : '';
    setSelectedContent({
      code: formatCode,
      name: selectedItem?.name,
      type: selectedItem?.type,
    });
  }, [formData, selectedFile, componentSnippetFront]);

  useEffect(() => {
    if (window && window.Prism) {
      window.Prism.highlightAll();
    }
  }, [selectedContent]);

  function onChangeLanguage(value) {
    if (value) {
      setSelectedFile(value);
    }
  }

  return (
    <div className="live-demo-snippet-container">
      {filesAvailable.length > 1 && (
        <>
          {liveDemoId === 'checkout-pro' ? (
            <div className="live-demo-snippet-list">
              <Dropdown
                type="form"
                label={i18n.gettext('Lenguaje')}
                defaultValue="javascript"
                onChange={(event, value) => {
                  Tracker.send(`mpdevelopers/live_demo/select_back_language_${liveDemoId}`, value);
                  onChangeLanguage(value);
                }}
              >
                {[...new Set(contentAvailable.map((item) => item.value))].map((value) => (
                  <DropdownItem key={value} value={value} title={value} />
                ))}
              </Dropdown>
            </div>
          ) : (
            <div className="live-demo-snippet-list">
              <span className="live-demo-snippet-label">Arquivos</span>
              {filesAvailable?.map((fileName) => (
                <Tag
                  label={fileName}
                  clickable
                  className={`live-demo-snippet-tag live-demo-snippet-tag${
                    selectedFile === fileName ? '--selected' : ''
                  }`}
                  onClick={() => {
                    setSelectedFile(fileName);
                  }}
                />
              ))}
            </div>
          )}

        </>

      )}

      <pre className={`language-${selectedContent?.type} line-numbers`}>
        <div className="live-demo-line-empty" />
        <code className={`language-${selectedContent?.type} line-numbers front`}>
          {`${selectedContent?.code}`}
        </code>
      </pre>
      <div className="live-demo-snippet-footer">
        <div className="live-demo-snippet-spacing download">
          <CopyToClipboard
            text={selectedContent?.code}
            onCopy={() => {
              Tracker.send(`mpdevelopers/live_demo/${liveDemoId}_click_front_download`, 'download');
            }}
          >
            <div
              role="button"
              className="live-demo-snippet-action"
              onClick={() => downloadString(selectedContent.code, 'snippet.html')}
              onKeyPress={(e) => e.key === 'Enter' && downloadString(selectedContent.code, 'snippet.html')}
              tabIndex="0"
            >
              <Download alt={i18n.gettext('Descargar código')} />
              <span>{i18n.gettext('Descargar')} </span>
            </div>
          </CopyToClipboard>
        </div>
        <div className="live-demo-snippet-spacing copy">
          <CopyToClipboard
            text={selectedContent?.code}
            onCopy={() => {
              Tracker.send(`mpdevelopers/live_demo/${liveDemoId}_click_front_copy`, 'copy');

              setBehaviorData(prev => ({
                ...prev,
                snackbarData: {
                  show: true,
                  message: i18n.gettext('Código copiado con éxito.'),
                  type: 'success',
                  delay: 3000,
                },
              }));
            }}
          >
            <div className="live-demo-snippet-action">
              <Copy alt={i18n.gettext('Copiar código')} />
              <span>{i18n.gettext('Copiar')}</span>
            </div>
          </CopyToClipboard>
        </div>
      </div>
    </div>
  );
};

module.exports = snippetFront;
